module.exports = __webpack_public_path__ + "static/media/209.2266b491.jpg";